import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export { loadRepositorySettingsAccessKeysResource } from './resources';

export const RepoSettingsAccessKeysResourceLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./access-keys'),
});

export const RepoSettingsAccessKeysLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./access-keys-legacy'),
});
